import React, { Component } from 'react';
import { Modal, DatePicker, Select, Input, Radio, message, Spin } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import SearchInput from '../../common/SearchInput';
import UploadFile from '../../common/UploadFile';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { Option } = Select;
const { TextArea } = Input;
const RadioGroup = Radio.Group;
const dateFormat = "YYYY-MM-DD";

class UpdateCustomerApprove extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        invOptions: [],
    }

    show = (parentRecord, record) => {
        const { userId, userCompellation, employeeCode } = parentRecord;
        const { fileList = [] } = record || {};
        fileList.forEach((item, index) => {
            item.response = { fileMetaId: item.fileMetaId };
            item.uid = index;
            item.name = item.fileName;
        });
        const params = {
            userId,
            ...(record || {}),
            employeeCode,
            userCompellation,
        };
        this.setState({
            params,
            isEdit: !!record,
            renderSponsor: false,
        }, () => {
            this.setState({
                visible: true,
                isUpload: false,
            });
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            invOptions: [],
        }, () => {
            const { isUpload = false, params: { userId } } = this.state;
            isUpload && this.props.loadData(userId);
        });
    }

    submit = () => {
        const {
            params: {
                userId,
                userAwardId,
                awardTime,
                awardType,
                awardComments,
                investigationId,
                fileList = [],
            },
            invOptions,
        } = this.state;
        if (!awardTime) {
            message.warning('请选择时间');
            return;
        }
        if (!investigationId) {
            message.warning('请选择项目简称');
            return;
        }
        if (!awardComments) {
            message.warning('请填写获得认可说明');
            return;
        }
        if (!awardType) {
            message.warning('请选择认可类型');
            return;
        }
        const files = {};
        if (fileList.length) {
            fileList.forEach((item, index) => {
                files[`ids[${index}]`] = item.response.fileMetaId;
            });
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.saveUserAward,
            data: {
                userId,
                userAwardId,
                awardTime: awardTime ? awardTime.slice(0, 10) : '',
                awardType,
                awardComments,
                investigationId,
                ...files,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = dateString;
        this.setState({ params });
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    handleUploadChange = (file, fileList) => {
        const { params } = this.state;
        params['fileList'] = fileList;
        this.setState({
            params,
            isUpload: true,
        });
    }

    // 项目简称
    invSelectChange = value => {
        const { invOptions, params, isEdit, renderSponsor =  false } = this.state;
        if (value) {
            const investigation = invOptions.find(i => i.value == value.key);
            const { sponsorName } = investigation || {};
            params.investigationId = value.key;
            if (!isEdit || (isEdit && renderSponsor)) {
                params.sponsorName = sponsorName;
            }
        } else {
            params.investigationId = '';
            params.sponsorName = '';
        }
        this.setState({
            params,
            renderSponsor: true,
        });
    }

    parseInvData = (res, value) => {
        if ((res.data || res.datas) ) {
            const sourceData = res.data ? res.data: res.datas;
            const data = sourceData.map(item => ({
                text: `${item.investigationName}`,
                value: item.investigationId,
                sponsorName: item.investigationSponsor,
                sponsorId: item.investigationSponsorId,
            }));
            this.setState({ invOptions: data });
        } else {
            this.setState({ invOptions: [] });
        }
    }

    getContent = () => {
        const { isEdit, params, visible, invOptions } = this.state;
        const {
            userId,
            awardTime,
            userCompellation,
            employeeCode,
            sponsorName,
            investigationId,
            investigationName,
            awardComments,
            awardType,
            userAwardId = '',
            fileList,
        } = params;
        const newAwardTime = awardTime ? moment(awardTime) : null;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">人员:</div>
                    <div className="item-right">
                            {`${userCompellation}[${employeeCode}]`}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}时间:</div>
                    <div className="item-right">
                        <DatePicker
                            placeholder="请选择"
                            style={{ width: 182 }}
                            format={dateFormat}
                            value={newAwardTime}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "awardTime")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}项目简称:</div>
                    <div className="item-right">
                        {
                            visible &&
                            <SearchInput
                                isEdit={isEdit}
                                keyword='investigationName'
                                style={{ width: 240 }}
                                placeholder="输入项目简称或编号自动检索"
                                params={{limit: 20, userId}}
                                url={API_URL.investigation.queryInvestigationByName}
                                initValue={{ key: investigationId, label: investigationName }}
                                dataSource={invOptions}
                                parseData={this.parseInvData}
                                handleSelect={this.invSelectChange}
                            />
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}申办方:</div>
                    <div className="item-right">{sponsorName || ''}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}获得认可说明:</div>
                    <div className="item-right">
                        <TextArea
                            rows={4}
                            maxLength="1000"
                            placeholder="请输入"
                            value={awardComments}
                            style={{ width: 240 }}
                            onChange={e => this.handleInputChange(e, 'awardComments')}
                        />
                    </div>
                    <p style={{position: 'relative', top: 2, marginBottom: -6, clear: 'left',textAlign: 'right', color: '#999'}}>{(awardComments || '').length}/1000</p>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}认可方式:</div>
                    <div className="item-right">
                        <Select
                            style={{ width: 182 }}
                            value={awardType || undefined}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'awardType')}
                        >
                            <Option value="PENNANT">锦旗</Option>
                            <Option value="TROPHY">奖杯</Option>
                            <Option value="CERTIFICATE_HONOR">荣誉证书</Option>
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">附件:</div>
                    <div className="item-right">
                        {
                            visible &&
                            <UploadFile
                                data={{
                                    userAwardId,
                                    path: Date.now(),
                                }}
                                number={30}
                                fileList={fileList}
                                uploadUrl={API_URL.user.uploadUserAwardFile}
                                removeUrl={API_URL.user.deleteUserAwardFile}
                                onChange={this.handleUploadChange}
                            />
                        }
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { isEdit, visible, loading } = this.state;
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}客户/研究者非邮件形式认可记录`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

class ExportModal extends Component {
    state = {
        params: {},
        visible: false,
    }

    show = (params) => {
        this.setState({
            visible: true,
            params:{...params},
        });
    }

    submit = () => {
        const { params, params: { type } } = this.state;
        if (!type) {
            message.warning('请选择附件导出方式');
            return;
        }

        ExportUtil.export(params, null, API_URL.user.downloadBatchUserAwardFile);
        ExportUtil.export(params, null, API_URL.user.exportUserInfoList);
        this.setState({ visible: false });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleRadioChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    render () {
        const { visible, params: { type } } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="480px"
            >
                <div className="modal-content" style={{ padding: '30px 20px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left">请选择附件导出方式：</div>
                            <div className="item-right" style={{ width: '70%', marginLeft: 60 }}>
                                <RadioGroup onChange={e => this.handleRadioChange(e, 'type')} value={type}>
                                    <Radio value="BY_INVESTIGATION">按项目简称分组导出</Radio>
                                    <Radio value="BY_SPONSOR">按申办方分组导出</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export { ExportModal, UpdateCustomerApprove };


// WEBPACK FOOTER //
// ./src/components/user/userInfo/UpdateCustomerApprove.js